import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Account from '../../_components/profile/account/account';
import Password from '../../_components/profile/password/password';
import Authentication from '../../_components/profile/authentication/authentication';
import Logs from '../../_components/profile/logs/logs';
import Navigation from '../../_components/profile/navigation/navigation';
import { fetchWrapper } from '../../_helpers';
import NavigationMobile from '../../_components/profile/navigationMobile/navigationMobile';

export { MyProfile };

function MyProfile() {
    // Defaults
    const navigate = useNavigate();
    const pageRoutes = {
        account: 'account',
        password: 'password',
        authenticator: 'authenticator',
        logs: 'logs',
    };
    const baseUrl = `${process.env.REACT_APP_API_URL}`;

    // State
    const [page, setPage] = useState(pageRoutes.account);
    const [userData, setUserData] = useState(null);
    const [userLogs, setUserLogs] = useState(null);

    // Fetch User Based On Session State
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const session_state = urlParams.get('session_state');

        setUserData(null);
        if (session_state) {
            fetchUser(session_state);
        } else {
            navigate('/');
        }
    }, []);

    const fetchUser = async (session_state) => {
        try {
            const responseUserData = await fetchWrapper.post(
                `${baseUrl}/profile`,
                {
                    session: session_state,
                }
            );

            const responseUserLogs = await fetchWrapper.post(
                `${baseUrl}/profile/user-log`,
                {
                    userId: responseUserData.id,
                }
            );

            setUserData(responseUserData);
            setUserLogs(responseUserLogs);
        } catch (error) {
            navigate('/');
        }
    };

    return (
        <>
            {/* Nav Here  */}
            <Navigation changeRoute={setPage} userData={userData} />
            <NavigationMobile changeRoute={setPage} userData={userData} />

            {userData !== null && userData !== undefined ? (
                <div className='container'>
                    <div className='row justify-content-center'>
                        {/* Pages */}
                        {page === pageRoutes.account ? (
                            <div className='col-sm-8 mt-5'>
                                <Account userData={userData} />
                            </div>
                        ) : page === pageRoutes.password ? (
                            <div className='col-sm-8 mt-5'>
                                <Password userData={userData} />
                            </div>
                        ) : // : page === pageRoutes.authenticator ? (
                        //     <div className='col-sm-8 mt-5'>
                        //         <Authentication />
                        //     </div>
                        // )
                        page === pageRoutes.logs ? (
                            <div className='mt-5'>
                                <Logs userLogs={userLogs} />
                            </div>
                        ) : null}
                    </div>
                </div>
            ) : (
                <div className='edit-profile-loader'>
                    <span
                        style={{ width: '50px', height: '50px' }}
                        className='spinner-border spinner-border-sm'
                    ></span>
                </div>
            )}
        </>
    );
}
